import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createStaticVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/viber.vue
var o = {
	name: "DtIconViber",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--viber"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Viber",
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("<path d=\"M21.19 2.34c-.596-.55-3.006-2.299-8.374-2.323 0 0-6.33-.381-9.416 2.45-1.718 1.717-2.322 4.231-2.386 7.348-.064 3.117-.146 8.959 5.484 10.542h.006L6.5 22.774s-.036.979.609 1.178c.779.242 1.236-.502 1.98-1.303.409-.44.973-1.087 1.397-1.58 3.851.323 6.813-.417 7.15-.527.777-.252 5.177-.816 5.892-6.657.739-6.02-.357-9.828-2.337-11.544z\" fill=\"#fff\"></path><path d=\"M19.938 3.557c-.504-.458-2.68-1.826-7.221-1.845 0 0-5.377-.354-7.987 2.01C3.277 5.158 2.788 7.29 2.734 9.894c-.054 2.603-.332 7.576 4.43 8.898l-.021 4.017c0 .227.036.382.165.414.094.023.233-.026.352-.144.761-.765 3.199-3.705 3.199-3.705 3.27.213 5.872-.432 6.152-.524.66-.212 4.228-.518 4.832-5.397.624-5.028-.23-8.46-1.905-9.895z\" fill=\"#7360f2\"></path><g stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\".6\"><path d=\"M15.026 9.68c-.06-1.191-.664-1.817-1.815-1.877\"></path><path d=\"M16.584 10.201c.024-1.109-.305-2.036-.986-2.78-.684-.747-1.632-1.158-2.847-1.247\"></path><path d=\"M18.178 10.825c-.015-1.925-.59-3.44-1.725-4.548-1.136-1.107-2.548-1.666-4.237-1.678\"></path></g><path d=\"M13.272 13.745s.427.036.656-.247l.448-.563c.216-.28.738-.458 1.249-.173.382.218.754.455 1.113.71.339.25 1.033.829 1.035.829.33.279.407.689.182 1.12l-.002.01c-.248.43-.563.817-.933 1.148l-.008.006c-.321.269-.637.421-.947.458a1.26 1.26 0 0 1-.54-.053l-.01-.015c-.478-.135-1.275-.472-2.603-1.204-.769-.42-1.5-.902-2.187-1.445a11.464 11.464 0 0 1-.984-.872l-.033-.033-.033-.033-.033-.033-.033-.033c-.31-.311-.6-.64-.872-.984a15.52 15.52 0 0 1-1.445-2.186c-.732-1.329-1.07-2.125-1.204-2.603l-.015-.01a1.26 1.26 0 0 1-.053-.541c.039-.31.191-.626.458-.948.003-.004.005-.004.007-.008.33-.37.718-.685 1.148-.932l.009-.002c.432-.225.842-.15 1.12.18.003.002.58.696.829 1.035.255.36.493.73.71 1.114.285.51.107 1.033-.172 1.248l-.564.448c-.284.23-.247.657-.247.657s.835 3.16 3.954 3.955z\" fill=\"#fff\"></path>", 4)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=viber.js.map